// helpers


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}}€";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'money_without_currency':
      value = formatWithDelimiters(cents, 2, '.', '.');
      break;
  }

  return value;
};

// CartManager
class CartManager {
  constructor() {
    let self = undefined;

    const CART_REQUEST_TYPES = {
      ADD: 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR: 'clear',
    };

    this.cart_request_type = CART_REQUEST_TYPES;
  }

  async getCart() {
    var shopifyCart = await this.fetchCart();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async getCartGTM() {
    var shopifyCart = await this.fetchCartGTM();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async updateNote(note, options) {
    const formData = {
      note: note,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
        options && typeof options.onSuccess === 'function'
          ? options.onSuccess
          : function () {},
      onFailure:
        options && typeof options.onFailure === 'function'
          ? options.onFailure
          : function () {},
      always:
        options && typeof options.always === 'function'
          ? options.always
          : function () {},
    });
  }

  handleErrors(options) {
    const errorMessage =
      options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;
  }

  async addItem(variant_id, quantity, properties, options) {
    const formData = {
      items: [
        {
          id: variant_id,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  updateItems(requests, onAllExecuted) {
    if (!Array.isArray(requests)) requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {},
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: [],
    };
    for (let request of requests) {
      let action = request.type;
      let items = request.items;
      if (action == this.cart_request_type.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error(
              'To add a new item both properties: ID & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.cart_request_type.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error(
              'To update an existing item, both properties: KEY & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          // TODO: Test if a normal item can be converted to a subscription using the change request.

          if (cartItem.properties)
            shopifyRequestsList.push({
              type: this.cart_request_type.CHANGE,
              body: cartItem,
            });
          else shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
      } else if (action == this.cart_request_type.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error('To remove an existing item KEY is required', item);
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.cart_request_type.UPDATE,
        body: shopifyUpdateRequest,
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.cart_request_type.ADD,
        body: shopifyAddRequest,
      });

    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = {requests_count: requestsCount};
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted();
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }
  }

  clearCart() {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  postShopify(formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue)) self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData,
      action,
      options,
    };
    self.requestsQueue.unshift(newRequest);

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData = currentRequest.formData;
    action = currentRequest.action;
    options = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {};
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {};
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {};

    if (action == this.cart_request_type.ADD) {
      url = window.routes.cartAddJS;
    } else if (action == this.cart_request_type.UPDATE) {
      url = window.routes.cartUpdateJS;
    } else if (action == this.cart_request_type.CHANGE) {
      url = window.routes.cartChangeJS;
    } else if (action == this.cart_request_type.CLEAR) {
      url = window.routes.cartClearJS;
    }
    // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(
        nextRequest.formData,
        nextRequest.action,
        nextRequest.options,
      );
    }
    // Otherwise, end execution.
    else
      return console.error(
        `Can't post to Shopify. The action: ${action} is not valid`,
      );

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (response.ok) return response.json();
        throw Error(response.statusText);
      })
      .then(function (cart) {
        try {
          options.onSuccess();
        } catch (e) {
          console.error(
            'Error executing onSuccess callback from postShopify',
            e,
          );
        }

        return {cart};
      })
      .catch(function (error) {
        self.handleErrors(error);

        try {
          options.onFailure();
        } catch (e) {
          console.error(
            'Error executing onFailure callback from postShopify',
            e,
          );
        }

        return {err: error};
      })
      .finally(function () {
        try {
          options.always();
        } catch (e) {
          console.error('Error executing always callback from postShopify', e);
        }

        // Handle next request if there are any in the queue.
        if (self.requestsQueue.length) {
          const nextRequest = self.requestsQueue.pop();
          return self.postShopify(nextRequest.formData, nextRequest.action);
        }
      });
  }

  async fetchCart(async) {
    var req = fetch(window.routes.cartJSON);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }

  async fetchCartGTM(async) {
    var req = fetch(window.routes.cartJSONGTM);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
}

const cartManager = new CartManager();

// Remove Button
customElements.define(
  'cart-remove-button',
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();

      this.removeEvent = new Event('remove', {bubbles: true});
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.dispatchEvent(this.removeEvent);
      });
    }
  },
);

// Cart items
customElements.define(
  'cart-items',
  class CartItems extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartNotification: 'cart-notification',
        variantSelects: 'variant-selects',
      };

      this.selectors = selectors;
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );
      this.variantSelects = document.querySelectorAll(
        this.selectors.variantSelects,
      );

      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0,
      );

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.addEventListener('remove', (event) => {
        this.updateQuantity(
          event.target.dataset.index,
          0,
          event.target.dataset.key,
          document.activeElement.getAttribute('name'),
          "remove",
          (event.target.dataset != null && event.target.dataset.removeGift != null) ? this.removeGift.bind(this) : "",
        );
      });
    }

     removeGift() {
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        event.target.dataset.key,
        document.activeElement.getAttribute('name'),
        event.detail
      );
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
        {
          id: 'cart-drawer-reward',
          section: document.getElementById('cart-drawer-reward') != null
                    ? document.getElementById('cart-drawer-reward').dataset.id
                    : null,
          selector: '[data-cart-drawer-reward]',
        },
        {
          id: 'cart-drawer-samples',
          section: document.getElementById('cart-drawer-samples') != null
                    ? document.getElementById('cart-drawer-samples').dataset.id
                    : null,
          selector: '[data-cart-drawer-samples]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        }
      ];
    }

    updateQuantity(line, quantity, variantID, name, action, callback) {
      this.enableLoading(line);
      console.log(action);

      localStorage.removeItem('cartView');

      localStorage.setItem('productUpdated', true);

      if (quantity == 0) {
        var button = this.querySelector(`#CartItem-${line}`).querySelector('[data-product-datalayer]');
        var dataGTM = JSON.parse(button.dataset.productDatalayer);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmRemoveCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      if (action == "minus" && quantity != 0) {
        var button = this.querySelector(`#CartItem-${line}`).querySelector('[data-product-datalayer]');
        var dataGTM = JSON.parse(button.dataset.productDatalayerQuantity);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmRemoveCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      if (action == "plus") {
        var button = this.querySelector(`#CartItem-${line}`).querySelector('[data-product-datalayer]');
        var dataGTM = JSON.parse(button.dataset.productDatalayerQuantity);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmAddToCartSidecart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch('/cart/change', {...fetchConfig(), ...{body}})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          
          //
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter)
            cartFooter.classList.toggle(
              'is-empty',
              parsedState.item_count === 0,
            );

          this.cartNotifications.forEach((section) => {
            section.updateItemsCount(parsedState.item_count);
          });

          this.variantSelects.forEach((section) => {
            section.reset();
          });

          this.getSectionsToRender().forEach((section) => {
            if(section.section != null) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              if (elementToReplace != null) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector,
                );
              }
            }
          });

          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`))
            lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading(line);

          if (callback && typeof callback == 'function') {
            callback();
          };
        })
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) =>
            overlay.classList.add('hidden'),
          );
          this.disableLoading(line);
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.add('cart__items--disabled');
      this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
        (overlay) => overlay.classList.remove('hidden'),
      );
      this.querySelector(`#CartItem-${line}`).classList.add('updating');
      document.activeElement.blur();
    }

    disableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.remove('cart__items--disabled');
        if (this.querySelector(`#CartItem-${line}`) != null) {
          this.querySelector(`#CartItem-${line}`).classList.remove('updating');
        }
    }
  },
);

// Quantity
customElements.define(
  'cart-quantity-input',
  class CartQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', {bubbles: true});

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this)),
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus'
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(new CustomEvent('change', {bubbles: true, detail: event.target.name}));
    }
  },
);

// Quantity
customElements.define(
  'cart-checkout-button',
  class cartCheckoutButton extends HTMLElement {
    constructor() {
      super();
      this.changeEvent = new Event('change', {bubbles: true});

      this.querySelectorAll('[data-checkout-cart-drawer]').forEach((button) =>
        button.addEventListener('click', this.redirectToCheckout.bind(this)),
      );
    }

    redirectToCheckout(event) {

      var elementGet = document.getElementById('items');
      var parseData = JSON.parse(elementGet.getAttribute('data-items'));
      var items = [];
      
      var dataLayerBeginChekout = function dataLayerBeginChekout() {
        for (var i = 0; i < parseData.length; i++) {
          items.push({
            currency: "EUR",
            item_name: parseData[i].title.replace(/\s+/g, "_").toLowerCase(),
            index: 1,
            item_brand: parseData[i].vendor.replace(/\s+/g, "_").toLowerCase(),
            item_list_name: parseData[i].handle.replace("-", "_").toLowerCase(),
            item_variant: parseData[i].variant_id,
            price: parseData[i].variant_id,
            item_id: parseData[i].price,
            quantity: parseData[i].quantity
          });
        }
      
        var dataBeginChekout = {
          event: "begin_chekout",
          ecommerce: {
            items: items
          }
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataBeginChekout);
      };

      var uriShop = Shopify.shop;
      var token;
      var hasSuscription = false;
      fetch('/cart.js').then(function (response) {
        return response.json();
      }).then(function (cart) {
        token = cart.token;
        var items = cart.items;
        var findShippingInterval = items.find(function (item) {
          if (item.properties) {
            if (item.properties.shipping_interval_frequency || item.properties.shipping_interval_unit_type) return item;
          }
        });
        if (findShippingInterval) hasSuscription = true;
        var urlCheckout;

        if (hasSuscription) {
          urlCheckout = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=".concat(uriShop, "&cart_token=").concat(token);
        } else {
          urlCheckout = Shopify.routes.root + "/cart/checkout";
        }

        window.location.href = urlCheckout;
        setTimeout(function () {
          document.querySelector('#sideCartButton .loader').remove();
        }, 5000);
      });
    }
  },
);

// Cart notification
customElements.define(
  'cart-notification',
  class CartNotification extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartCount: '[data-cart-count]',
      };
      this.selectors = selectors;
      this.cartNotification = this.querySelector(this.selectors.cartCount);
    }

    updateItemsCount(itemsCount) {
      if (!this.cartNotification) return;

      this.cartNotification.innerHTML = itemsCount;
    }

    getItemsCount() {
      if (!this.cartNotification) return;
      return this.cartNotification.innerHTML;
    }
  },
);

// Cart Drawer
customElements.define(
  'cart-drawer-z',
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartOpen: '[data-cart-drawer-open]',
        cartClose: '[data-cart-drawer-close]',
        cartDrawer: 'cart-drawer-v2',
        cartOverlay: 'cart-overlay',
        cartNotification: 'cart-notification',
        cartUpsellDynamic: 'cart-upsell-dynamic',
      };

      this.selectors = selectors;
      this.cartDrawer = document.getElementById(this.selectors.cartDrawer);
      this.cartOverlay = document.getElementById(this.selectors.cartOverlay);
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );
      this.cartUpsellDynamic = document.querySelector(
        this.selectors.cartUpsellDynamic,
      );

      this.cartDrawer.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close(),
      );

      document
        .querySelectorAll(this.selectors.cartOpen)
        .forEach((cartOpen) =>
          cartOpen.addEventListener('click', this.handleCartUpdates.bind(this), false),
        );

      this.init();
    }

    init() {
      // Detect cart interactions
      this.httpInterceptor(
        [
          '/cart/add.js',
          '/cart/add',
          '/cart/change',
          '/cart/update?drawer-item-reward',
          '/cart/clear',
        ],
        this.handleCartUpdates.bind(this),
      );
    }

    async open() {

      if (localStorage.getItem('cartView') == null) {
        localStorage.setItem('cartView', true);

        const shopifyCartGTM = await cartManager.getCartGTM();

        console.log(shopifyCartGTM);
        var items = [];
        for (let index = 0; index < shopifyCartGTM.items.length; index++) {
          items.push({
            "index": shopifyCartGTM.items[index].index,
            "item_name": shopifyCartGTM.items[index].title,
            "item_id": shopifyCartGTM.items[index].sku,
            "item_barcode": shopifyCartGTM.items[index].product_id,
            "item_category": shopifyCartGTM.items[index].item_category,
            "item_category2": shopifyCartGTM.items[index].item_category2,
            "item_variant": shopifyCartGTM.items[index].item_variant,
            "pack": shopifyCartGTM.items[index].pack,
            "product_related1": shopifyCartGTM.items[index].product_related1,
            "product_related2": shopifyCartGTM.items[index].product_related2,
            "price": Shopify.formatMoneyNumber(shopifyCartGTM.items[index].original_price),
            "quantity": shopifyCartGTM.items[index].quantity,
            "item_selection":(shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._item_selection != null) ? shopifyCartGTM.items[index].properties._item_selection : "usual",
            "discount": (shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._pack != null) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].total_discount) : (shopifyCartGTM.items[index].discounts != 0) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].discounts) : 0,
          })
        };
  
        var dataEvent_2 = {
          value: Shopify.formatMoneyNumber(shopifyCartGTM.total_price),
          items: items
        };
  
        var evt_2 = new CustomEvent("gtmviewCart", {'detail': dataEvent_2});
        window.dispatchEvent(evt_2);
  
        var dataEvent = {
          "page_type_1": "funnel",
          "page_type_2": "cart",
          "category_1": "na",
          "category_2": "na",
          "environment": datalayer_environment,
          "language": datalayer_language,
          "hashed_256_email": datalayer_hashed_256_email,
          "customer_id": datalayer_customer_id,
          "user_status_login": datalayer_user_status_login,
          "nl_subscriber": datalayer_nl_subscriber
        };
  
        var evt = new CustomEvent("gtmPageviewCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      this.cartDrawer.classList.add('animate', 'active');
      this.cartOverlay.classList.add('animate', 'active');
      document.querySelector('body').style.overflow = 'hidden';
    }

    close() {
      this.cartDrawer.classList.remove('active');
      this.cartOverlay.classList.remove('active');
      document.querySelector('body').style.overflow = 'scroll';

      localStorage.removeItem('cartView');

      if (window.location.href.indexOf('/cart') > -1) {
        window.location.href = "/"
      }
    }



    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
        {
          id: 'cart-drawer-reward',
          section: document.getElementById('cart-drawer-reward') != null
                    ? document.getElementById('cart-drawer-reward').dataset.id
                    : null,
          selector: '[data-cart-drawer-reward]',
        },
        {
          id: 'cart-drawer-samples',
          section: document.getElementById('cart-drawer-samples') != null
                    ? document.getElementById('cart-drawer-samples').dataset.id
                    : null,
          selector: '[data-cart-drawer-samples]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    async renderContents(refreshContentsAllow) {
      await fetch(`${window.routes.cart_url}?sections=cart-drawer-v2`, {
        method: 'GET',
      })
        .then((response) => response.json())
        .then((response) => {

          this.getSectionsToRender().forEach((section) => {
            if(section.section != null) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              if (elementToReplace != null) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  response["cart-drawer-v2"],
                  section.selector,
                );
              }
            }
          });

          document
            .querySelectorAll(this.selectors.cartClose)
            .forEach((cartClose) =>
              cartClose.addEventListener('click', this.close.bind(this)),
            );

            if(document.querySelector('#cart-progressbar-rewards') != null) {
              this.cartProgressBarSampless = document.querySelector('#cart-progressbar-rewards');
              this.cartProgressBarSampless.init();
            }
            if(document.querySelector('#cart-drawer-shipping-estimate') != null) {
              this.cartProgressBarSampless = document.querySelector('#cart-drawer-shipping-estimate');
              this.cartProgressBarSampless.init();
            }

            if(document.querySelector('cart-upsell-dynamic') != null) {
              console.log('ok');
              this.cartUpsellDynamic = document.querySelector('cart-upsell-dynamic');
              this.cartUpsellDynamic.init();
            }
          
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      this.open();
      this.initCheckoutButton();
    }

    initCheckoutButton() {
      var checkoutButton = this.cartDrawer.querySelector('[data-checkout-cart-drawer]');
      checkoutButton.addEventListener('click', function(e) {
        window.location = Shopify.routes.root + "checkout";
      });
    }
    async addGhostProduct(variantId) {
      localStorage.setItem('ghostProductIsAdding', true);
      const result = await fetch("/cart/add", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                "_is_ghost_product": true
              }
          })
      }).then((response) => {
        return response.text();
      })
      .then((state) => {
        if (localStorage.getItem('ghostProductIsAdding')) {
          localStorage.removeItem('ghostProductIsAdding');
        }
      })
      .catch(() => {

      });
    }

    async removeGhostProduct(variantId) {
      const result = await fetch("/cart/change", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId.toString(),
              quantity: 0
          })
      }).then((response) => {
        return response.text();
      })
      .then((state) => {
        

  
      })
      .catch(() => {

      });
    }

    async handleCartUpdates(res, url) {
      if (res != undefined && res.target != undefined && res.target) {
        res.preventDefault();
      }
      const shopifyCart = await cartManager.getCart();
      this.cartNotifications.forEach((section) => {
        section.updateItemsCount(shopifyCart.item_count);
      });
      
      if (this.cartProgressBarGift != null) {
        this.cartProgressBarGift.init();
      }
      let refreshContentsAllow = true;

      if (localStorage.getItem('noteUpdated')) {
        localStorage.removeItem('noteUpdated');
        refreshContentsAllow = false;
      }
      if (localStorage.getItem('productUpdated')) {
        localStorage.removeItem('productUpdated');
        refreshContentsAllow = true;
      }

       // Logique d'ajout d'un produit gratuit pour les abonnés, pour faire apparaitre les modes de livraison
      //  if(window.location.href.includes("https://www.lashilebeauty.com/")) {

      //   console.log('Cart ', shopifyCart);
      //   var onlySubscription = true;
      //   var foundGhostProduct = false;
      //   var ghostProductVariantId = 41871711830202;
 
      //   for (let index = 0; index < shopifyCart.items.length; index++) {
      //    let item = shopifyCart.items[index];
      //    if(!item.selling_plan_allocation && item.variant_id != ghostProductVariantId) onlySubscription = false;
      //    if(item.variant_id == ghostProductVariantId) foundGhostProduct = true;
      //   }
 
      //   console.log("onlySubscription");
      //   console.log(onlySubscription);

      //  // Add ghost product if only subscription item(s) in cart
      //  if(onlySubscription && !foundGhostProduct && shopifyCart.items.length > 0 && !localStorage.getItem('ghostProductIsAdding')) {
      //   console.log('add');
      //   await this.addGhostProduct(ghostProductVariantId);
      //  }

      //  // Remove ghost product if non subscription item(s) in cart
      //  if(!onlySubscription && foundGhostProduct && shopifyCart.items.length > 0) {
      //   console.log('remove');
      //   await this.removeGhostProduct(ghostProductVariantId);
      //   refreshContentsAllow = true;
      //  }

      //  // Remove ghost product if only this ghost product in cart
      //  if(foundGhostProduct && shopifyCart.items.length == 1) {
      //   console.log('remove');
      //   await this.removeGhostProduct(ghostProductVariantId);
      //   refreshContentsAllow = true;
      //  }

      //  if (foundGhostProduct) {
      //   this.cartNotifications.forEach((section) => {
      //     section.updateItemsCount(shopifyCart.item_count - 1);
      //   });
      //  }
      // }

      if (refreshContentsAllow) {
        await this.renderContents(refreshContentsAllow);
      }
    }

    async httpInterceptor(urlmatchs, callback) {
      var responseMatchesAnyUrl = function (requestUrl, urls) {
        if (!Array.isArray(urls)) urls = [urls];

        for (const url of urls) {
          if (!requestUrl.includes(url)) continue;
          return true;
        }

        return false;
      };

      // Intercept fetch.
      const constantMock = window.fetch;
      window.fetch = function () {
        return new Promise((resolve, reject) => {
          constantMock
            .apply(this, arguments)
            .then(async (response) => {
              try {
                if (
                  responseMatchesAnyUrl(response.url, urlmatchs) &&
                  response.type != 'cors' &&
                  response.ok
                ) {
                  let json = await response.clone().json();
                  if (typeof callback === 'function')
                    await callback(json, response.url);
                }
              } catch (err) {
                console.error(
                  'Something went wrong while intercepting cart update',
                  err,
                );
              }
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      };

      // Intercept Ajax.
      let send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        this.addEventListener(
          'readystatechange',
          async function () {
            if (
              responseMatchesAnyUrl(this.responseURL, urlmatchs) &&
              this.readyState === 4 &&
              this.status == 200
            ) {
              if (typeof callback === 'function')
                await callback(JSON.parse(this.response), this.responseURL);
            }
          },
          false,
        );
        send.apply(this, arguments);
      };

      // TODO: Listen to HTML form submits.
      // Intercept HTML Forms.
      document.addEventListener(
        'submit',
        function (e) {
          // Valid the target.
          if (
            !e.target ||
            e.target.tagName.toLowerCase() !== 'form' ||
            e.target.matches('[sz-no-block]')
          )
            return;
          // Validate the URL.
          var form = e.target;
          var submitButton = e.submitter;
          var actionUrl = new URL(form.action);
          var actionPath = actionUrl.pathname;
          if (!actionPath.includes('/cart')) return;

          e.preventDefault();
          this.cartDrawer = document.querySelector('cart-drawer-z');


          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.headers['Content-Type'] = "application/json";

          var quickAdd = document.querySelector("[data-quickadd-popup]");

          const formData = new FormData(form);
          var object = {};
          formData.forEach(function(value, key) {
              if (key.includes('properties[')) {
                  let propertyKey = key.replace('properties[', '').replace(']', '');
                  object.properties = object.properties || {};
                  object.properties[propertyKey] = value;
              } else {
                  object[key] = value;
              }
          });

          var json = object;
          json.properties = json.properties || {};

          if (quickAdd && quickAdd.style.display == "block") {
              json.properties["_item_selection"] = "quick_access";
          } else {
              json.properties["_item_selection"] = "usual";
          }
          
          config.body = JSON.stringify(json);

          console.log(config.body);


          // Close quickadd popup
          
          if (quickAdd && quickAdd.style.display == "block") {
            var item_selection = "quick_access";
          } else {
            var item_selection = "usual";
          }
          if (quickAdd != undefined) quickAdd.style.display = "none";

          var isUpsell = false;
          if (submitButton.classList.contains('product-card-upsell_button')) {
            isUpsell = true;
          }

          var item_variant = "simple";
          if (formData.get('selling_plan') != '' && formData.get('selling_plan') != null) {
            item_variant = "VIP";
          }

          fetch('/cart/add', config)
            .then((response) => response.json())
            .then(async function (response) {
              if (response.status) {
                console.log(response.description);
                return;
              }


              if (actionPath == "/cart/add" || actionPath == "/en/cart/add" || actionPath == "/nl-be/cart/add" ) {
                var dataEvent = {
                  "item_name":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_name'),
                  "item_id":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_id'),
                  "item_barcode":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_barcode'),
                  "item_category":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_category'),
                  "item_category2":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_category2'),
                  "item_variant":item_variant,
                  "pack":"na",
                  "product_related1":"na",
                  "product_related2":"na",
                  "price":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('data-price')),
                  "currency":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-gtm-currency'),
                  "item_selection":item_selection,
                  "discount":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('data-discount')),
                };
          
                var evt = new CustomEvent("gtmAddToCart", {'detail': dataEvent});
                window.dispatchEvent(evt);
              }
  
              if (typeof callback === 'function')
                await callback(undefined, response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {});
        }.bind(this),
      );
    }
  },
);